import React from 'react';

/**
 * ErrorBubble — shared validation error tooltip for form fields.
 * Renders a floating red bubble above the field with an arrow indicator.
 */
export const ErrorBubble = ({ message }: { message?: string }) => {
    if (!message) return null;
    return (
        <div className="absolute z-10 bottom-[72%] right-0 mb-1 text-xs text-white bg-red-600 rounded px-2.5 py-1.5 shadow-lg animate-in fade-in slide-in-from-top-1 pointer-events-none">
            {message}
            <div className="absolute -bottom-1 right-3 w-2 h-2 bg-red-600 rotate-45" />
        </div>
    );
};
